import React from "react";
import { ContentTable } from "./ContentTable";

export const TableDanhSach = ({ isLoading, listNguonKH, dbName, onReload, onDelete, onDataChanged}) => {

    return (
        <>
            {isLoading ? (
                <div className="loading-page1"><div className="loader loader-default is-active"></div></div>
            ) : (
                <div className="Left808x200 Table-main-new css-table-ds">
                    <div className="table-mobile table-mobile-hover">
                        <div className="custom-table-wrapper" style={{ overflowX: "auto", width: '100%' }}>
                            <div className="table-headers" style={{alignItems: 'stretch'}}>
                                <div className="custom-table-header text-left flex-basis-50 flex-basis-50-sm">
                                    <p>Tên nguồn khách hàng</p>
                                </div>
                                <div className="custom-table-header text-center flex-basis-25 flex-basis-25-sm">
                                    <p>Active</p>
                                </div>
                                <div className="custom-table-header text-center flex-basis-25 flex-basis-25-sm">
                                    <p>Thao tác</p>
                                </div>
                            </div>
                            <div className="custom-table-body">
                                <ContentTable
                                    listNguonKH={listNguonKH}
                                    dbName={dbName}
                                    onReload={onReload}
                                    onDelete={onDelete}
                                    onDataChanged={onDataChanged}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};